<template>
  <div class="section-board">
    <header class="tree__container">
      <h2 class="tree__title">
        Construir mi IVR tipo {{ botDetails?.type ? BotTypeText[botDetails.type] : "" }}
      </h2>
    </header>

    <template v-if="!botNodes?.length">
      <section class="empty__container">
        <p>Selecciona una opción y agrega acciones que comuniquen mejor con tus contactos.</p>

        <div class="card__container">
          <CreateNodeCard
            v-if="botDetails?.type === BotType.Survey"
            :type="NodeType.SatisfactionRanking"
            :disabled="botDetails.status === BotStatus.Active"
            text="Agregar encuesta de satisfacción"
            id="ivr-survey-node"
            @click="handleCreateNode"
          />

          <CreateNodeCard
            v-if="botDetails?.type === BotType.Automatic"
            :type="NodeType.NumericDialing"
            :disabled="botDetails.status === BotStatus.Active"
            text="Agregar marcación numérica"
            @click="handleCreateNode"
          />

          <CreateNodeCard
            v-if="botDetails?.type === BotType.Automatic"
            :type="NodeType.VariableCapture"
            :disabled="botDetails.status === BotStatus.Active"
            text="Agregar capturar variable"
            @click="handleCreateNode"
          />
        </div>
      </section>
    </template>

    <template v-else>
      <CustomScrollbar class="scroll">
        <NodesTree
          :bot-nodes="botNodes"
          :parent-node="undefined"
          @open-settings="handleOpen"
          @close-settings="(id) => emit('close-settings', id)"
        />
      </CustomScrollbar>
    </template>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { useRoute } from "vue-router";
import { message } from "ant-design-vue";

import { BotStatus, BotType, NodeType } from "@/app/ivr/bot/utils/enums";
import { BotTypeText } from "@/app/ivr/bot/utils/texts";
import { nodeServices } from "@/app/ivr/bot/services/NodeServices";
import { FetchNodesKey, BotNodesKey, BotDetailsKey } from "@/@types/ivr/symbols";
import { ResponseError } from "@/app/shared/utils/httpManager";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

import CreateNodeCard from "@/app/ivr/bot/components/cards/CreateNodeCard.vue";
import NodesTree from "@/app/ivr/bot/components/tree/NodesTree.vue";

const emit = defineEmits<{
  (e: "open-settings", id: number): void;
  (e: "close-settings", id: number[]): void;
}>();

const route = useRoute();

const botDetails = inject(BotDetailsKey);
const botNodes = inject(BotNodesKey);
const fetchNodes = inject(FetchNodesKey);

const handleCreateNode = async (type: NodeType) => {
  try {
    await nodeServices.create(Number(route.params.id), type);
  } catch (error) {
    const errorMessage =
      error instanceof ResponseError ? error.getErrorMessage() : "Ha ocurrido un error";

    message.error(errorMessage);
  }

  fetchNodes?.();
};

const handleOpen = (id: number) => emit("open-settings", id);
</script>

<style scoped lang="sass">
.section-board
  height: 100%
  border-top: 1px solid $gray-5
  background-color: #FFFFFF
  flex: 1 1 auto

.card__container
  display: flex
  gap: 16px

.empty__container
  padding: 12px 28px

.tree
  &__container
    padding: 12px 16px
    border-bottom: 1px solid #F0F0F0

  &__title
    font-weight: 400
    font-size: 16px
    color: $gray-9
    margin: 0

.scroll
  padding: 12px 16px
  height: calc(100% - 51px)
</style>
